(() => {
  if (window.__eug) return;
  window.__eug = true;

  const lock = (on) => document.documentElement.classList.toggle('eug-lock', on);
  const svgCache = {};
  const loadSvg = (src) => (svgCache[src] ||= fetch(src).then((r) => r.text()));

  // Brand/Modell dürfen sich nicht überlappen: Breite pro Feld begrenzen
  const FIELD_MAX = 124;
  const fitField = (el, max) => {
    try {
      if (el.getComputedTextLength() > max) {
        el.setAttribute('textLength', max);
        el.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      }
    } catch (_) {}
  };

  // GARAN-Label: offizielle Vorlage laden und nur die 3 editierbaren Felder befüllen
  const renderGaran = async (body) => {
    if (!body || body.dataset.done) return;
    body.dataset.done = '1';
    try {
      const txt = await loadSvg(body.dataset.garanSrc);
      const svg = new DOMParser().parseFromString(txt, 'image/svg+xml').documentElement;
      const set = (k, v) => { const t = svg.querySelector(`[data-eug="${k}"]`); if (t) t.textContent = v || ''; return t; };
      const years = set('years', body.dataset.years);
      const brand = set('brand', body.dataset.brand);
      const model = set('model', body.dataset.model);
      if (years && (body.dataset.years || '').length > 2) {
        years.setAttribute('textLength', '104');
        years.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      }
      svg.setAttribute('aria-label', body.getAttribute('aria-label') || 'GARAN');
      body.removeAttribute('aria-label');
      body.replaceChildren(document.importNode(svg, true));
      const fonts = document.fonts ? document.fonts.load('400 9px "EUG Inter"') : Promise.resolve();
      fonts.finally(() => {
        const live = body.querySelector('svg');
        fitField(live.querySelector('[data-eug="brand"]'), FIELD_MAX);
        fitField(live.querySelector('[data-eug="model"]'), FIELD_MAX);
      });
    } catch (e) {
      delete body.dataset.done;
      console.error('GARAN label', e);
    }
  };

  const prepare = (dialog) => {
    if (!dialog) return;
    dialog.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
    const g = dialog.querySelector('[data-garan-src]');
    if (g) loadSvg(g.dataset.garanSrc);
  };

  // Vorladen, sobald Interesse erkennbar ist
  const pre = (e) => {
    const t = e.target.closest?.('[data-eug-open]');
    if (t) prepare(document.getElementById(t.dataset.eugOpen));
  };
  document.addEventListener('pointerover', pre, { passive: true });
  document.addEventListener('touchstart', pre, { passive: true });
  document.addEventListener('focusin', pre);

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-eug-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.eugOpen);
      if (d && !d.open) {
        prepare(d);
        renderGaran(d.querySelector('[data-garan-src]'));
        d.showModal();
        lock(true);
      }
      return;
    }
    if (e.target.closest('[data-eug-close]')) {
      e.target.closest('dialog')?.close();
      return;
    }
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('eug__dialog')) {
      e.target.close();
    }
  });

  document.addEventListener('close', (e) => {
    if (e.target.classList?.contains('eug__dialog')) lock(false);
  }, true);
})();
